import React from 'react';
import styles from './styles';
import ChildForm from './ChildForm';
import {Form, IconTextButton, Icons, StaticSearch} from '@xpertdox_js/xdcomponents';
import {btn_c_lightGreen} from '@xpertdox_js/xdstyle';
import { trackActivity } from '../../../../../utils/activityTracker'
import { UserContext } from '../../../../../Context/UserContext'
import { InstanceContext } from '../../../../../InstanceContext'

const TsDsEdit = props => {

const isTsDs = props.type !== undefined;
  const state = !isTsDs ? props.state : props.type === 'inc' ? props.incState.value : props.excState.value;
  const antiState = !isTsDs ? {} : props.type === 'inc' ? props.excState.value : props.incState.value;
  const setState = !isTsDs ? props.setState : props.type === 'inc' ? props.incState.setter : props.excState.setter;

  // top level form state
  const [mainFormState, setMainFormState] = React.useState({});
  const [selected, setSelected] = React.useState(Object.keys(state).length > 0 ? Object.keys(state) : []);
  const [changeState, setChangeState] = React.useState({...state});
  const { user } = React.useContext(UserContext)
  const { contextInstance } = React.useContext(InstanceContext)

  const handleActivityLogUpdate = (_id) => {
    trackActivity({
      body: {
        _id,
        instance: contextInstance || user.instance,
        user: user.id
      }
    })
  }

  const handleSelect = value => {
    let current = selected.slice();
    current.push(value);
    setSelected(current);
  }
  const handleRemove = value => {
    let current = selected.filter(val => val !== value);
    setSelected(current);
  }

  const {options} = props;
  const filterOptions = () => {
    let filteredOptions = {};
    const reduceArray = (stateArray, antiStateArray) => {
      return stateArray.filter(item => !antiStateArray.includes(item));
    }
    const reduceObject = (stateObject, antiStateObject) => {
      let reducedObject = {};
      Object.keys(stateObject).forEach((stateKey, i) => {
        if (Array.isArray(stateObject[stateKey])) {
          // if key in antiState && both arrays are empty delete this option
          if (stateObject[stateKey].length === 0
          && antiStateObject[stateKey]
          && Array.isArray(antiStateObject[stateKey])
          && antiStateObject[stateKey].length === 0) {
            // no set ?
          // if key in antiState && both arrays and antiState not empty reduce this array
          } else if (stateObject[stateKey].length
          && antiStateObject[stateKey]
          && Array.isArray(antiStateObject[stateKey])
          && antiStateObject[stateKey].length) {
            reducedObject[stateKey] = reduceArray(stateObject[stateKey], antiStateObject[stateKey]);
          // if antistate equivelent is undefined set options as is
        } else if (!antiStateObject || antiStateObject[stateKey] === undefined) {
            reducedObject[stateKey] = stateObject[stateKey];
          }
        } else if (typeof stateObject[stateKey] === 'object') {
          reducedObject[stateKey] = reduceObject(stateObject[stateKey] || {}, antiStateObject[stateKey] || {})
        }
      });
      return reducedObject;
    }
    return reduceObject(options, antiState || {})
  }
  const optionsFiltered = isTsDs ? filterOptions() : options;

  const topLevelOptions = Object.keys(optionsFiltered);
  const masterFormID = 'top_level_' + props.dataType + '_' + props.type;

  const updateChangeState = (value) => {
    setChangeState(value);
  }

  // track changes to force parent to refresh
  const changeTrack = React.useRef(null);
  // initialize ref after formstate is initialized
  if (changeTrack.current === null && selected)
    changeTrack.current = selected;
  // on change update refresh state by 1
  if (changeTrack.current !== null && changeTrack.current !== selected) {
    props.setRefreshState(props.refreshState + 1);
    changeTrack.current = selected;
    let change = {...state};
    selected.forEach(property => {
      change[property] = {...change[property]};
    })
    updateChangeState(change)
    props.handleHeight();
  }


  const currentValue = Array.isArray(props.data) ? props.data : props.data !== null && props.data !== undefined ? Object.keys(props.data) : [];

  // has value changed
  const hasChanged = changeState !== state;


  const compileAndUpdate = () => {
    handleActivityLogUpdate(`TsDsEdit.compileAndUpdate`)
    setState(changeState);
    props.handleSubmit(changeState, true);
  }



  return(
    <div style={styles.container}>
      <div style={styles.contentContainer}>
        <div style={styles.mainFormContainer}>
          <StaticSearch
            options={topLevelOptions}
            handleSelect={handleSelect}
            selected={selected}
          />
        </div>
        <div style={styles.childContainer}>
          {selected.length > 0 && selected.map((item, i) => (<ChildForm
            setRefreshState={props.setRefreshState}
            refreshState={props.refreshState}
            handleRemove={handleRemove}
            updateChangeState={updateChangeState}
            changeState={changeState}
            key={item}
            property={item}
            value={state[item] || []}
            options={optionsFiltered[item]}
            id={masterFormID + '_' + item}
          />))}
        </div>
      </div>
      {/* save update button */}
      {hasChanged &&
        <IconTextButton
          styles={{borderRadius: '10rem'}}
          preBuiltStyles={btn_c_lightGreen}
          onClick={compileAndUpdate}
          icon='checkmark'
          text='Update Value'
        />
      }
    </div>
  )
}


  export default TsDsEdit;
